"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.props = void 0;

var _assert = require("../assert");

var _is = require("../is");

var _toTypeString = require("../to-type-string");

const props = source => {
  (0, _assert.assert)(source, _is.isObject, actual => `"props" expects first argument to be an instance of Object, but was given "${(0, _toTypeString.toTypeString)(actual)}"`);
  return Promise.all(Object.values(source)).then(values => {
    return Object.keys(source).reduce((acc, key, index) => {
      return { ...acc,
        [key]: values[index]
      };
    }, {});
  });
};

exports.props = props;